// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

type CamposIbsCbsProps = {
  component : React.ComponentType<*>,
}

export default function CamposIbsCbs({ component } : CamposIbsCbsProps) {
  const SelecaoTodos = component || SelecaoTodosNfe;

  return (
      <FormSection name="dadosItemIbsCbs">
        <SelecaoTodos nomes={ ['dadosItemIbsCbs'] } titulo="Informações do IBS e da CBS"/>

        <div className="grupo-checkbox">
          <Input name="cstIbsCbs" label="CST" checkbox/>
          <Input name="codClassTribIbsCbs" label="Cód. Classificação Tributária" checkbox/>
          <Input name="indicadorDoacaoIbsCbs" label="Indicador de Doação" checkbox/>
          <Input name="valorBcIbsCbs" label="BC do IBS e CBS" checkbox/>

          <SubtituloSelecao titulo="IBS para a UF"/>
          <Input name="aliquotaIbsUf" label="Alíquota" checkbox/>
          <Input name="percDiferimentoIbsUf" label="Perc. Diferimento" checkbox/>
          <Input name="valorDiferimentoIbsUf" label="Valor Diferimento" checkbox/>
          <Input name="valorTribDevolvidoIbsUf" label="Valor Tributo Devolvido" checkbox/>
          <Input name="percRedAliqCClassTribIbsUf" label="Perc. Redução Alíq. cClassTrib" checkbox/>
          <Input name="aliquotaEfetivaIbsUf" label="Alíquota Efetiva" checkbox/>
          <Input name="valorIbsUf" label="Valor IBS UF" checkbox/>

          <SubtituloSelecao titulo="IBS para o Município"/>
          <Input name="aliquotaIbsMun" label="Alíquota" checkbox/>
          <Input name="percDiferimentoIbsMun" label="Perc. Diferimento" checkbox/>
          <Input name="valorDiferimentoIbsMun" label="Valor Diferimento" checkbox/>
          <Input name="valorTribDevolvidoIbsMun" label="Valor Tributo Devolvido" checkbox/>
          <Input name="percRedAliqCClassTribIbsMun" label="Perc. Redução Alíq.
            cClassTrib" checkbox/>
          <Input name="aliquotaEfetivaIbsMun" label="Alíquota Efetiva" checkbox/>
          <Input name="valorIbsMun" label="Valor IBS Município" checkbox/>

          <SubtituloSelecao titulo="Total do IBS"/>
          <Input name="valorIbs" label="Valor do IBS" checkbox/>

          <SubtituloSelecao titulo="Informações da CBS"/>
          <Input name="aliquotaCbs" label="Alíquota" checkbox/>
          <Input name="percDiferimentoCbs" label="Perc. Diferimento" checkbox/>
          <Input name="valorDiferimentoCbs" label="Valor Diferimento" checkbox/>
          <Input name="valorTribDevolvidoCbs" label="Valor Tributo Devolvido" checkbox/>
          <Input name="percRedAliqCClassTribCbs" label="Perc. Redução Alíq. cClassTrib" checkbox/>
          <Input name="aliquotaEfetivaCbs" label="Alíquota Efetiva" checkbox/>
          <Input name="valorCbs" label="Valor CBS" checkbox/>

          <SubtituloSelecao titulo="Informações da Tributação Regular"/>
          <Input name="cstIbsCbsTribReg" label="CST IBS e CBS" checkbox/>
          <Input name="codClassTribIbsCbsTribReg" label="Cód Class. Tributária IBS e CBS" checkbox/>
          <Input name="aliquotaIbsUfTribReg" label="Alíquota IBS da UF" checkbox/>
          <Input name="tribIbsUfTribReg" label="Tributo do IBS da UF" checkbox/>
          <Input name="aliquotaIbsMunTribReg" label="Alíquota IBS do Município" checkbox/>
          <Input name="tribIbsMunTribReg" label="Tributo do IBS do Município" checkbox/>
          <Input name="aliquotaCbsTribReg" label="Alíquota CBS" checkbox/>
          <Input name="tribCbsTribReg" label="Tributo da CBS" checkbox/>

          <SubtituloSelecao titulo="Informações da Composição do IBS/CBS em Compras Governamentais"/>
          <Input name="aliquotaIbsUfComprasGov" label="Alíquota IBS da UF" checkbox/>
          <Input name="tribIbsUfComprasGov" label="Tributo do IBS da UF" checkbox/>
          <Input name="aliquotaIbsMunComprasGov" label="Alíquota IBS do Município" checkbox/>
          <Input name="tribIbsMunComprasGov" label="Tributo do IBS do Município" checkbox/>
          <Input name="aliquotaCbsComprasGov" label="Alíquota CBS" checkbox/>
          <Input name="tribCbsComprasGov" label="Tributo do CBS" checkbox/>

          <SubtituloSelecao titulo="Informações IBS/CBS em operações com imposto monofásico"/>
          <Input name="qtdTribImpostoMonofasico" label="Quantidade tributada na monofasia" checkbox/>
          <Input name="aliquotaAdRemIbsImpostoMonofasico" label="Alíquota ad rem do IBS" checkbox/>
          <Input name="aliquotaAdRemCbsImpostoMonofasico" label="Alíquota ad rem da CBS" checkbox/>
          <Input name="valorIbsMonoImpostoMonofasico" label="Valor IBS monofásico" checkbox/>
          <Input name="valorCbsMonoImpostoMonofasico" label="Valor CBS monofásica" checkbox/>
          <Input name="qtdTribRetencaoImpostoMonofasico" label="Quantidade tributada sujeita à retenção " checkbox/>
          <Input name="aliquotaAdRemIbsRetencaoImpostoMonofasico" label="Alíquota ad rem do IBS sujeito à retenção"
                 checkbox/>
          <Input name="valorIbsRetencaoImpostoMonofasico" label="Valor IBS monofásico sujeito à retenção" checkbox/>
          <Input name="aliquotaAdRemCbsRetencaoImpostoMonofasico" label="Alíquota ad rem da CBS sujeito à retenção"
                 checkbox/>
          <Input name="valorCbsRetencaoImpostoMonofasico" label="Valor da CBS monofásica sujeita à retenção" checkbox/>
          <Input name="qtdTribRetAnterImpostoMonofasico" label="Qtd tributada retida anteriormente" checkbox/>
          <Input name="aliquotaAdRemIbsRetAnterImpostoMonofasico" label="Alíq. ad rem do IBS retido anteriormente"
                 checkbox/>
          <Input name="valorIbsRetAnterImpostoMonofasico" label="Valor IBS retido anteriormente" checkbox/>
          <Input name="aliquotaAdRemCbsRetAnterImpostoMonofasico" label="Alíq. ad rem CBS retida anteriormente"
                 checkbox/>
          <Input name="valorCbsRetAnterImpostoMonofasico" label="Valor CBS retida anteriormente" checkbox/>
          <Input name="percDifIbsImpostoMonofasico" label="Perc. Diferim. Imp. Monof. IBS" checkbox/>
          <Input name="ibsMonDiferImpostoMonofasico" label="IBS monofásico diferido" checkbox/>
          <Input name="percDifCbsImpostoMonofasico" label="Perc. Diferim. Imp. Monof. CBS" checkbox/>
          <Input name="cbsMonDiferImpostoMonofasico" label="CBS monofásica diferida" checkbox/>
          <Input name="totalIbsMonoImpostoMonofasico" label="Total IBS Monofásico" checkbox/>
          <Input name="totalCbsMonoImpostoMonofasico" label="Total CBS Monofásica" checkbox/>

          <SubtituloSelecao titulo="Transferências de Crédito"/>
          <Input name="valorIbsTransfCredito" label="Valor IBS a ser transferido" checkbox/>
          <Input name="valorCbsTransfCredito" label="Valor CBS a ser transferida" checkbox/>

          <SubtituloSelecao titulo="Ajuste de Competência"/>
          <Input name="anoMesAjusteCompetencia" label="Ano/mês do período de apuração" checkbox/>
          <Input name="valorIbsAjusteCompetencia" label="Valor IBS" checkbox/>
          <Input name="valorCbsAjusteCompetencia" label="Valor CBS" checkbox/>

          <SubtituloSelecao titulo="Estorno de Crédito"/>
          <Input name="valorIbsEstornoCredito" label="Valor IBS a ser estornado" checkbox/>
          <Input name="valorCbsEstornoCredito" label="Valor CBS a ser estornada" checkbox/>

          <SubtituloSelecao titulo="Crédito Presumido da Operação"/>
          <Input name="valorBcCredPresumOperacao" label="Valor BC Crédito Presumido" checkbox/>
          <Input name="codClassifCredPresumOperacao" label="Cód. Classificação Crédito Presumido" checkbox/>

          <SubtituloSelecao titulo="Crédito Presumido IBS"/>
          <Input name="percCredPresumIbs" label="Percentual do Crédito Presumido" checkbox/>
          <Input name="valorCredPresumIbs" label="Valor Crédito Presumido" checkbox/>
          <Input name="valorCondSuspensivaCredPresumIbs" label="Valor Crédito Presumido condição suspensiva" checkbox/>

          <SubtituloSelecao titulo="Crédito Presumido CBS"/>
          <Input name="percCredPresumCbs" label="Percentual do Crédito Presumido" checkbox/>
          <Input name="valorCredPresumCbs" label="Valor Crédito Presumido" checkbox/>
          <Input name="valorCondSuspensivaCredPresumCbs" label="Valor Crédito Presumido condição suspensiva" checkbox/>

          <SubtituloSelecao titulo="Apropriação de Crédito Presumido de IBS sobre saldo ZFM"/>
          <Input name="anoMesCredPresumIbsSobSaldoZfm" label="Ano/mês do período de apuração" checkbox/>
          <Input name="tipClassifCredPresumIbsSobSaldoZfm" label="Tipo classif. para cálculo" checkbox/>
          <Input name="valorCredPresumIbsSobSaldoZfm" label="Valor crédito pres. calculado sobre saldo devedor"
                 checkbox/>
        </div>
      </FormSection>
  );
}

function SubtituloSelecao({ titulo } : { titulo : string }) {
  return <label title=""><span className="selecao-todos-texto">{ titulo }</span></label>
}